import React from "react";
import {
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import AddBoxIcon from "@mui/icons-material/AddBox";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ArticleIcon from "@mui/icons-material/Article";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const quickMenus = [
    { title: "Kullanıcıları Yönet", path: "/admin/kullanicilar", icon: <PersonIcon sx={{ color: "#4caf50" }} fontSize="large" /> },
    { title: "Firmaları Yönet", path: "/admin/firmalar", icon: <BusinessIcon sx={{ color: "#2196f3" }} fontSize="large" /> },
    { title: "Dış İlan Yönet", path: "/admin/other-posts", icon: <ArticleIcon sx={{ color: "#ff9800" }} fontSize="large" /> },
    { title: "Hızlı İlan", path: "/admin/fast-post", icon: <NoteAddIcon sx={{ color: "#9c27b0" }} fontSize="large" /> },
    { title: "Blog Yazısı Ekle", path: "/admin/create-blog", icon: <AddBoxIcon sx={{ color: "#f44336" }} fontSize="large" /> },
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Admin Dashboard'a Hoş Geldiniz
      </Typography>

      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        Hızlı işlemler için aşağıdaki menülerden birini seçin.
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        {quickMenus.map((menu, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 3,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: 6,
                },
                background: "linear-gradient(135deg, #ffffff, #f0f0f0)"
              }}
            >
              <CardActionArea onClick={() => navigate(menu.path)}>
                <CardContent sx={{ textAlign: "center", py: 5 }}>
                  <Box sx={{ mb: 2 }}>{menu.icon}</Box>
                  <Typography variant="h6" fontWeight="bold">
                    {menu.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
